import React, { useRef, useEffect, useState } from 'react';
import {
  Marker,
} from 'react-leaflet';
import { Browser } from 'leaflet';

import Icon from './Icon';

import 'leaflet/dist/leaflet.css';

const MarkerComponent = ({
  map,
  defaultPosition,
  movedMarker,
}) => {
  const markerRef = useRef();
  const [markerPosition, setMarkerPosition] = useState(defaultPosition);

  useEffect(() => {
    setMarkerPosition(defaultPosition);
  }, [defaultPosition]);

  useEffect(() => {
    const clickFunction = (e) => {
      setMarkerPosition(e.latlng);
      map.flyTo(e.latlng, !markerPosition ? 12 : map.getZoom(), { duration: 0.5 });
      movedMarker(e.latlng);
    };
    if (map) {
      map.on('click', clickFunction);
    }

    return () => {
      if (map) {
        map.off('click', clickFunction);
      }
    };
  }, [map, markerPosition]);

  if (!markerPosition) return null;

  return (
    <>
      <Marker
        ref={markerRef}
        draggable={!Browser.mobile}
        position={markerPosition}
        eventHandlers={{
          dragend: () => {
            const markerObj = markerRef.current;
            if (markerObj) {
              setMarkerPosition(markerObj.getLatLng());
              map.flyTo(markerObj.getLatLng(), map.getZoom(), { duration: 0.5 });
              movedMarker(markerObj.getLatLng());
            }
          },
        }}
        icon={Icon}
      />
    </>
  );
};

export default MarkerComponent;
